import { css } from 'lit'

export default css`
*:focus-visible {
  outline: 0.2rem solid var(--hh-color-focus);
  outline-offset: var(--hh-focus-outline-offset);
}

textarea:focus-visible,
input:not([type="checkbox"]):not([type="radio"]):focus-visible  {
  outline: none !important;
}

.focus-inset:focus-visible {
  outline: 0.2rem solid var(--hh-color-focus);
  outline-offset: var(--hh-focus-outline-offset);
}

/* Fallback */
.focus-inset:focus {
  outline: 0.2rem solid var(--hh-color-focus);
  outline-offset: var(--hh-focus-outline-offset);
}

.focus-inset:focus:not(:focus-visible) {
  outline: 0;
  border: 0;
  box-shadow: none;
}

.skip-to-content-link:focus {
  z-index: var(--hh-z-highest);
  position: inherit;
  overflow: auto;
  width: auto;
  height: auto;
  clip: auto;
}

/* Dangerous for a11y - Use with care */
.focus-none {
  box-shadow: none !important;
  outline: 0 !important;
}
`